(function () {
  try {

    /* ======================================================
       LENIS + GSAP (SAFE INIT)
    ====================================================== */
    if (window.Lenis && window.gsap) {
      const lenis = new Lenis({
        smoothWheel: true,
        smoothTouch: false,
        normalizeWheel: true,
        ignore: el => el.classList.contains("scroll-section")
      });

      lenis.on("scroll", () => {
        window.ScrollTrigger && ScrollTrigger.update();
      });

      gsap.ticker.add(time => {
        lenis.raf(time * 700);
      });
    }

gsap.ticker.lagSmoothing(0),
document.addEventListener("DOMContentLoaded", function() {
    const logo = document.querySelector(".logo");
    window.addEventListener("scroll", function() {
        window.scrollY > 50 ? (logo.classList.remove("not-scrolled"),
        logo.classList.add("scrolled")) : (logo.classList.remove("scrolled"),
        logo.classList.add("not-scrolled"))
    })
}),
document.addEventListener("DOMContentLoaded", function () {

  const menuButton = document.querySelector(".mob_menu"),
        menuData = document.querySelector(".header-menu-data-box"),
        navbar = document.querySelector(".navbar"),
        searchBox = document.querySelector(".search-container-cust");

  menuButton.addEventListener("click", function () {

    this.classList.toggle("active");
    menuData.classList.toggle("active");

    if (location.pathname === "/") {

      if (menuData.classList.contains("active")) {
        navbar.classList.add("bg_change");
        navbar.classList.add("nav-bg_white");
        navbar.setAttribute("data-page", "notHome");
      } else {
        navbar.classList.remove("bg_change");

        if (window.scrollY < 10) {
          navbar.classList.remove("nav-bg_white");
        }

        navbar.setAttribute("data-page", "home");
      }

    }

  });

  window.opensearchbox = function () {

    searchBox.classList.toggle("active");

    if (location.pathname === "/") {

      if (searchBox.classList.contains("active")) {
        navbar.classList.add("bg_change");
        navbar.classList.add("nav-bg_white");
        navbar.setAttribute("data-page", "notHome");
      } else {

        navbar.classList.remove("bg_change");

        if (window.scrollY < 10) {
          navbar.classList.remove("nav-bg_white");
        }

        navbar.setAttribute("data-page", "home");

      }

    }

  };

});
    /* ======================================================
       LOGO CHANGE ON SCROLL
    ====================================================== */
    window.addEventListener("scroll", () => {
      document.body.classList.toggle("logo-scrolled", window.scrollY > 50);
    }, { passive: true });

    /* ======================================================
       IST TIME
    ====================================================== */
    function updateTime() {
      const el = document.getElementById("indian-time");
      if (!el) return;

      el.textContent = `[ INDIA ${new Date().toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata"
      })} ]`;
    }
    updateTime();
    setInterval(updateTime, 1000);

    /* ======================================================
       DOM READY
    ====================================================== */
    document.addEventListener("DOMContentLoaded", () => {

      /* ================= HEADER SCROLL ================= */
      const headerMain = document.querySelector(".header-main");
      if (headerMain) {
        let lastScroll = window.pageYOffset;
        const headerHeight = headerMain.offsetHeight;

        window.addEventListener("scroll", () => {
          const current = window.pageYOffset;
          headerMain.classList.toggle("off-canvas", current > headerHeight);
          headerMain.classList.toggle("fixed", current < lastScroll);
          lastScroll = current;
        }, { passive: true });
      }

      /* ================= INTERSECTION OBSERVERS ================= */
      if ("IntersectionObserver" in window) {
        const header = document.querySelector(".evemen-header");
        const wearitHeader = document.querySelector(".wearit-header-nav-container");

        const observe = (el, cls, threshold = 0.6) => {
          if (!el) return;
          new IntersectionObserver(entries => {
            entries.forEach(entry => {
              header?.classList.toggle(cls, entry.isIntersecting);
              wearitHeader?.classList.toggle(cls, entry.isIntersecting);
            });
          }, { threshold }).observe(el);
        };

        observe(document.querySelector(".one-decade-hero_section"), "in-hero", 0.6);
        observe(document.querySelector(".od1"), "in-hero1", 0.6);
      }

      // /* ================= INFINITE AUTO SCROLL ================= */
      // if (window.innerWidth >= 1024) {
      //   document.querySelectorAll(
      //     ".option1-data .carousel, .collection .slider-mobile-gutter .grid"
      //   ).forEach(container => {
      //     if (!container || container._init) return;
      //     container._init = true;

      //     [...container.children].forEach(el => {
      //       const clone = el.cloneNode(true);
      //       clone.classList.add("clone");
      //       container.appendChild(clone);
      //     });

      //     let paused = false;
      //     const speed = 0.6;

      //     const loop = () => {
      //       if (!paused) {
      //         container.scrollLeft += speed;
      //         if (container.scrollLeft >= container.scrollWidth / 2) {
      //           container.scrollLeft = 0;
      //         }
      //       }
      //       requestAnimationFrame(loop);
      //     };

      //     container.addEventListener("mouseenter", () => paused = true);
      //     container.addEventListener("mouseleave", () => paused = false);
      //     container.addEventListener("touchstart", () => paused = true, { passive: true });
      //     container.addEventListener("touchend", () => paused = false);

      //     loop();
      //   });
      // }

      // /* ================= DRAG SCROLL (MOUSE + TOUCH) ================= */
      // function enableDrag(container) {
      //   if (!container) return;

      //   let down = false;
      //   let startX = 0;
      //   let scrollLeft = 0;

      //   const start = x => {
      //     down = true;
      //     startX = x;
      //     scrollLeft = container.scrollLeft;
      //     container.classList.add("is-dragging");
      //   };

      //   const move = x => {
      //     if (!down) return;
      //     container.scrollLeft = scrollLeft - (x - startX);
      //   };

      //   const end = () => {
      //     down = false;
      //     container.classList.remove("is-dragging");
      //   };

      //   container.addEventListener("mousedown", e => start(e.pageX));
      //   container.addEventListener("mousemove", e => move(e.pageX));
      //   container.addEventListener("mouseup", end);
      //   container.addEventListener("mouseleave", end);

      //   container.addEventListener("touchstart", e => start(e.touches[0].pageX), { passive: true });
      //   container.addEventListener("touchmove", e => move(e.touches[0].pageX), { passive: true });
      //   container.addEventListener("touchend", end);
      // }

      // const initDrag = () => {
      //   [".product-grid", ".predictive-search__results-list"].forEach(sel => {
      //     document.querySelectorAll(sel).forEach(el => {
      //       if (!el._dragInit) {
      //         enableDrag(el);
      //         el._dragInit = true;
      //       }
      //     });
      //   });
      // };

      // initDrag();
      // new MutationObserver(initDrag).observe(document.body, { childList: true, subtree: true });

      /* ================= TAB CLICK ================= */
      document.querySelectorAll(".evemen-info-details-tab ul li").forEach(li => {
        li.addEventListener("click", () => {
          const content = li.querySelector(".evemen-info-details-tab-sub-content");
          if (!content) return;

          const active = content.classList.contains("active");
          document.querySelectorAll(".evemen-info-details-tab ul li").forEach(i => i.classList.remove("active"));
          document.querySelectorAll(".evemen-info-details-tab-sub-content").forEach(c => c.classList.remove("active"));

          if (!active) {
            li.classList.add("active");
            content.classList.add("active");
          }
        });
      });

      /* ================= GRID SWITCH ================= */
      const wrapper = document.querySelector(".cust-collection-page2");
      if (!wrapper) return;

      const grid = wrapper.querySelector(".grid");
      const options = wrapper.querySelectorAll("#grid-options li[data-columns]");
      const eVid1 = wrapper.querySelector(".product-grid .e-vid-1");
      const eVid2 = wrapper.querySelector(".product-grid .e-vid-2");
      const grid1 = wrapper.querySelector(".grid .grid__item:first-child");
      const grid6 = wrapper.querySelector(".grid .grid__item:nth-child(6)");

      options.forEach(option => {
        option.addEventListener("click", () => {
          const cols = +option.dataset.columns;
          const items = grid.querySelectorAll(".grid__item");

          option.parentNode.querySelectorAll(".active").forEach(a => a.classList.remove("active"));
          option.classList.add("active");

          grid.style.display = cols === 1 ? "unset" : "grid";
          grid.style.gridTemplateColumns = `repeat(${cols},1fr)`;
          grid.classList.toggle("add-class-6", cols === 6);
          grid.classList.toggle("add-class-3", cols === 3);

          if (!eVid1 || !grid1) return;

          eVid1.style.display = items.length > cols ? "block" : "none";
          eVid2 && (eVid2.style.display = items.length > cols * 2 ? "block" : "none");
        });
      });

    });

  } catch (e) {
    // console.error("JS FILE CRASHED:", e);
  }
})();


window.showSizeGuide = function(id) {

  // remove active from tabs
  document.querySelectorAll(".size2-option").forEach(el=>{
    el.classList.remove("active");
  });

  // remove active from charts
  document.querySelectorAll(".chart-container").forEach(el=>{
    el.classList.remove("active");
  });

  // activate clicked tab
  event.currentTarget.classList.add("active");

  // activate chart
  const chart = document.getElementById(id);
  if(chart){
    chart.classList.add("active");
  }

};

// open size guide
window.openSizeBox = function() {
  const box = document.querySelector(".size-2-body-container");
  if (box) {
    box.classList.add("up");
  }
};

// close size guide
window.removeGuide = function() {
  const box = document.querySelector(".size-2-body-container");
  if (box) {
    box.classList.remove("up");
  }
};